import React from "react";
import SaitButton from "../atomic/SaitButton";
import { IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";

export default function GridToolbarReloadButton(props) {
	return props.toolbarIcons ? (
		<IconButton loading={props.isFiltering} onClick={props.handleFireFilter} disabled={props.disableToolbarFilterButton}>
			<CachedIcon color="primary" />
		</IconButton>
	) : (
		<SaitButton loading={props.isFiltering} onClick={props.handleFireFilter} icon={<CachedIcon />} variant="text" disabled={props.disableToolbarFilterButton} />
	);
}
